export enum SearchField {
  JOB_DESCRIPTION = 'jobDescription',
  JOB_NAME = 'jobName',
}
